import React from 'react'
import { RouteChildrenType } from 'types'

const RouteChildrenContext = React.createContext<
  RouteChildrenType[] | undefined
>(undefined)

export default RouteChildrenContext
